export default function ForceMajeure() {
  return (
    <p>
      Neither the Information Service Provider nor the Customer shall be liable for breaching this Contract for Services where that breach results from “Force Majeure.”
      <br /><br />
      Force Majeure refers to any event that is beyond the reasonable control of the parties and includes, but is not limited to: power failure, internet Information Service Provider failure or other third party service provider failure, industrial action, civil unrest, theft, fire, flood, storms, earthquakes, acts of terrorism, acts of war, governmental action or any other event that is beyond the control of the party in question.
    </p>
  );
}
